import AuthService from '../../security/AuthService';
import config from '../../security/config.json';

const CLIENT_ID = config['clientid'];
const DOMAIN = config['domain'];
const REDIRECT_URI = config['redirectUri'];
const auth = new AuthService( CLIENT_ID, DOMAIN, REDIRECT_URI );

const initialState = { auth };
const SET_REDIRECT_URI = 'SET_REDIRECT_URI';

export default function reducer( state = initialState, action ) {
  switch( action.type ) {
  case SET_REDIRECT_URI: {
    let auth = state.auth;
    auth.setRedirectUri( action.payload );
    let newstate = { ...state, auth: auth };
    return newstate;
  }
  default: 
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js